var _defs, _polyline, _polyline2, _polyline3, _polyline4, _polyline5, _polyline6, _polyline7, _line, _polyline8, _line2, _polyline9, _line3, _polyline10, _line4, _polyline11, _polyline12, _polyline13, _polyline14, _polyline15, _polyline16, _polyline17, _line5, _polyline18, _line6, _polyline19, _line7, _polyline20, _line8, _polyline21, _polyline22, _polyline23, _polyline24, _polyline25, _polyline26, _line9, _polyline27, _line10, _polyline28, _line11, _polyline29, _line12, _polyline30, _polyline31, _polyline32, _polyline33, _polyline34, _polyline35, _polyline36, _line13, _polyline37, _line14, _polyline38, _line15, _polyline39, _line16, _polyline40, _polyline41, _polyline42, _polyline43, _polyline44, _polyline45, _polyline46, _line17, _polyline47, _line18, _polyline48, _line19, _polyline49, _polyline50;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDensitateWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ebe6a874-9c58-4d84-af34-3b3d094cc75c",
    "data-name": "densitate",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 196 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622{fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "densitate_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "177.85 68.96 177.85 90.74 177.85 105.26 177.85 127.04"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "177.85 141.56 177.85 163.33 177.85 177.85 177.85 196"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "177.85 54.44 177.85 32.67 177.85 18.15 177.85 0"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "163.33 68.96 163.33 90.74 163.33 105.26 163.33 127.04"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "163.33 141.56 163.33 163.33 163.33 177.85 163.33 196"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "163.33 54.44 163.33 32.67 163.33 18.15 163.33 0"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "141.56 32.67 141.56 54.44 141.56 68.96 141.56 90.74"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 141.56,
    y1: 196,
    x2: 141.56,
    y2: 177.85
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "141.56 163.33 141.56 141.56 141.56 127.04 141.56 105.26"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 141.56,
    y1: 18.15,
    x2: 141.56
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "127.04 32.67 127.04 54.44 127.04 68.96 127.04 90.74"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 127.04,
    y1: 196,
    x2: 127.04,
    y2: 177.85
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "127.04 163.33 127.04 141.56 127.04 127.04 127.04 105.26"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 127.04,
    y1: 18.15,
    x2: 127.04
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 68.96 105.26 90.74 105.26 105.26 105.26 127.04"
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 141.56 105.26 163.33 105.26 177.85 105.26 196"
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 54.44 105.26 32.67 105.26 18.15 105.26 0"
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 68.96 90.74 90.74 90.74 105.26 90.74 127.04"
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 141.56 90.74 163.33 90.74 177.85 90.74 196"
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 54.44 90.74 32.67 90.74 18.15 90.74 0"
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "68.96 32.67 68.96 54.44 68.96 68.96 68.96 90.74"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 68.96,
    y1: 196,
    x2: 68.96,
    y2: 177.85
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "68.96 163.33 68.96 141.56 68.96 127.04 68.96 105.26"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 68.96,
    y1: 18.15,
    x2: 68.96
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "54.44 32.67 54.44 54.44 54.44 68.96 54.44 90.74"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 54.44,
    y1: 196,
    x2: 54.44,
    y2: 177.85
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "54.44 163.33 54.44 141.56 54.44 127.04 54.44 105.26"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 54.44,
    y1: 18.15,
    x2: 54.44
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "32.67 68.96 32.67 90.74 32.67 105.26 32.67 127.04"
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "32.67 141.56 32.67 163.33 32.67 177.85 32.67 196"
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "32.67 54.44 32.67 32.67 32.67 18.15 32.67 0"
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "18.15 68.96 18.15 90.74 18.15 105.26 18.15 127.04"
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "18.15 141.56 18.15 163.33 18.15 177.85 18.15 196"
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "18.15 54.44 18.15 32.67 18.15 18.15 18.15 0"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 18.15,
    y1: 177.85,
    y2: 177.85
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 177.85 127.04 177.85 141.56 177.85 163.33 177.85"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 196,
    y1: 177.85,
    x2: 177.85,
    y2: 177.85
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 177.85 68.96 177.85 54.44 177.85 32.67 177.85"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 18.15,
    y1: 163.33,
    y2: 163.33
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 163.33 127.04 163.33 141.56 163.33 163.33 163.33"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 196,
    y1: 163.33,
    x2: 177.85,
    y2: 163.33
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 163.33 68.96 163.33 54.44 163.33 32.67 163.33"
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "0 141.56 18.15 141.56 32.67 141.56 54.44 141.56"
  })), _polyline32 || (_polyline32 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "196 141.56 177.85 141.56 163.33 141.56 141.56 141.56"
  })), _polyline33 || (_polyline33 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "127.04 141.56 105.26 141.56 90.74 141.56 68.96 141.56"
  })), _polyline34 || (_polyline34 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "0 127.04 18.15 127.04 32.67 127.04 54.44 127.04"
  })), _polyline35 || (_polyline35 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "196 127.04 177.85 127.04 163.33 127.04 141.56 127.04"
  })), _polyline36 || (_polyline36 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "127.04 127.04 105.26 127.04 90.74 127.04 68.96 127.04"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 18.15,
    y1: 105.26,
    y2: 105.26
  })), _polyline37 || (_polyline37 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 105.26 127.04 105.26 141.56 105.26 163.33 105.26"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 196,
    y1: 105.26,
    x2: 177.85,
    y2: 105.26
  })), _polyline38 || (_polyline38 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 105.26 68.96 105.26 54.44 105.26 32.67 105.26"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 18.15,
    y1: 90.74,
    y2: 90.74
  })), _polyline39 || (_polyline39 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 90.74 127.04 90.74 141.56 90.74 163.33 90.74"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 196,
    y1: 90.74,
    x2: 177.85,
    y2: 90.74
  })), _polyline40 || (_polyline40 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 90.74 68.96 90.74 54.44 90.74 32.67 90.74"
  })), _polyline41 || (_polyline41 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "0 68.96 18.15 68.96 32.67 68.96 54.44 68.96"
  })), _polyline42 || (_polyline42 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "196 68.96 177.85 68.96 163.33 68.96 141.56 68.96"
  })), _polyline43 || (_polyline43 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "127.04 68.96 105.26 68.96 90.74 68.96 68.96 68.96"
  })), _polyline44 || (_polyline44 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "0 54.44 18.15 54.44 32.67 54.44 54.44 54.44"
  })), _polyline45 || (_polyline45 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "196 54.44 177.85 54.44 163.33 54.44 141.56 54.44"
  })), _polyline46 || (_polyline46 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "127.04 54.44 105.26 54.44 90.74 54.44 68.96 54.44"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 18.15,
    y1: 32.67,
    y2: 32.67
  })), _polyline47 || (_polyline47 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "105.26 32.67 127.04 32.67 141.56 32.67 163.33 32.67"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 196,
    y1: 32.67,
    x2: 177.85,
    y2: 32.67
  })), _polyline48 || (_polyline48 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 32.67 68.96 32.67 54.44 32.67 32.67 32.67"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    x1: 18.15,
    y1: 18.15,
    y2: 18.15
  })), _polyline49 || (_polyline49 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "196 18.15 177.85 18.15 163.33 18.15 141.56 18.15 127.04 18.15 105.26 18.15"
  })), _polyline50 || (_polyline50 = /*#__PURE__*/React.createElement("polyline", {
    className: "b9b84d8c-4e57-40ba-9b44-7bbe9ebfa622",
    points: "90.74 18.15 68.96 18.15 54.44 18.15 32.67 18.15"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDensitateWhite);
export default __webpack_public_path__ + "static/media/densitate_white.85cef29d384af64ac005d929b01dc05c.svg";
export { ForwardRef as ReactComponent };